import { getExperimentsConfig } from './getExperimentsConfig';
export const getExperimentFromConfig = id => {
  return getExperimentsConfig()[id];
};